import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './AuthDialog.scss';

import {
    Dialog
} from 'components/controls';
import LoginFormContainer from './Login/LoginFormContainer';


export default class LoginDialog extends Component {
    static propTypes = {
        onClose: PropTypes.func.isRequired,
        onSignUpLinkClick: PropTypes.func.isRequired,
        onForgotPasswordClick: PropTypes.func.isRequired
    };


    render() {
        const {onClose, onSignUpLinkClick, onForgotPasswordClick} = this.props;
        return (
            <Dialog title={loc('login-label')}
                    dialogClassName={styles.dialog}
                    containerClassName={styles.dialogBody}
                    contentClassName={styles.content}
                    onClose={onClose}>
                <LoginFormContainer onClose={onClose} onSignUpLinkClick={onSignUpLinkClick}
                                    onForgotPasswordClick={onForgotPasswordClick}/>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Auth/LoginDialog.js